export const exams = [
    {
        id: 'jee-main',
        name: 'JEE Main',
        fullName: 'Joint Entrance Examination - Main',
        category: 'Engineering',
        level: 'National',
        conductingBody: 'National Testing Agency (NTA)',
        description: 'The Joint Entrance Examination (Main) is the gateway for admission to B.E./B.Tech courses at NITs, IIITs, other Centrally Funded Technical Institutions (CFTIs), and Institutions/Universities funded/recognized by participating State Governments.',
        website: 'https://jeemain.nta.nic.in',
        logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/82/JEE_Main_logo.svg/1200px-JEE_Main_logo.svg.png', // Placeholder or simple icon usage in UI
        dates: {
            applicationStart: 'November 2025',
            applicationEnd: 'December 2025',
            admitCard: 'January 2026',
            examDate: 'January 24 - February 1, 2026',
            result: 'February 12, 2026'
        },
        pattern: {
            mode: 'Computer Based Test (CBT)',
            duration: '3 Hours',
            totalMarks: 300,
            sections: [
                { name: 'Physics', questions: '20 + 10 (Numerical)', marks: 100 },
                { name: 'Chemistry', questions: '20 + 10 (Numerical)', marks: 100 },
                { name: 'Mathematics', questions: '20 + 10 (Numerical)', marks: 100 }
            ],
            markingScheme: '+4 for Correct, -1 for Incorrect'
        },
        eligibility: [
            'Passed Class 12 or equivalent examination.',
            'Physics and Mathematics as mandatory subjects along with Chemistry/Biology/Technical Vocational subject.',
            'No age limit for appearing in JEE Main.'
        ]
    },
    {
        id: 'neet-ug',
        name: 'NEET UG',
        fullName: 'National Eligibility cum Entrance Test (Undergraduate)',
        category: 'Medical',
        level: 'National',
        conductingBody: 'National Testing Agency (NTA)',
        description: 'NEET UG is the single entrance test for admissions to more than 66,000 MBBS and BDS seats across India. It is mandatory for pursuing medical courses in India and abroad.',
        website: 'https://neet.nta.nic.in',
        dates: {
            applicationStart: 'February 2026',
            applicationEnd: 'March 2026',
            admitCard: 'May 2026',
            examDate: 'May 3, 2026 (First Sunday)',
            result: 'June 2026'
        },
        pattern: {
            mode: 'Pen and Paper Based Test',
            duration: '3 Hours 20 Minutes',
            totalMarks: 720,
            sections: [
                { name: 'Physics', questions: '45', marks: 180 },
                { name: 'Chemistry', questions: '45', marks: 180 },
                { name: 'Biology (Botany + Zoology)', questions: '90', marks: 360 }
            ],
            markingScheme: '+4 for Correct, -1 for Incorrect'
        },
        eligibility: [
            'Passed Class 12 or equivalent with Physics, Chemistry, Biology/Biotechnology and English.',
            'Minimum 50% aggregate marks in PCB for General category (40% for Reserved).',
            'Minimum 17 years of age at the time of admission.'
        ]
    },
    {
        id: 'ap-eapcet',
        name: 'AP EAPCET',
        fullName: 'Andhra Pradesh Engineering, Agriculture and Pharmacy Common Entrance Test',
        category: 'Engineering & Medical',
        level: 'State (Andhra Pradesh)',
        conductingBody: 'JNTU Anantapur on behalf of APSCHE',
        description: 'AP EAPCET is a state-level entrance exam for admission into Engineering, Agriculture, and Pharmacy courses in colleges across Andhra Pradesh.',
        website: 'https://cets.apsche.ap.gov.in',
        dates: {
            applicationStart: 'March 2026',
            applicationEnd: 'April 2026',
            admitCard: 'May 2026',
            examDate: 'May 15-23, 2026',
            result: 'June 2026'
        },
        pattern: {
            mode: 'Computer Based Test (CBT)',
            duration: '3 Hours',
            totalMarks: 160,
            sections: [
                { name: 'Mathematics / Biology', questions: '80', marks: 80 },
                { name: 'Physics', questions: '40', marks: 40 },
                { name: 'Chemistry', questions: '40', marks: 40 }
            ],
            markingScheme: '+1 for Correct, No Negative Marking'
        },
        eligibility: [
            'Indian National and resident of Andhra Pradesh/Telangana.',
            'Passed Class 12 with relevant subjects (MPC for Engineering, BiPC for Agri/Pharm).',
            'Minimum 16 years of age.'
        ]
    },
    {
        id: 'ts-eamcet',
        name: 'TS EAMCET',
        fullName: 'Telangana State Engineering, Agriculture & Medical Common Entrance Test',
        category: 'Engineering & Medical',
        level: 'State (Telangana)',
        conductingBody: 'JNTU Hyderabad on behalf of TSCHE',
        description: 'TS EAMCET conducts admissions for Engineering, Agriculture, and Medical (Pharmacy, Veterinary etc.) streams in Telangana state colleges.',
        website: 'https://eamcet.tsche.ac.in',
        dates: {
            applicationStart: 'February 2026',
            applicationEnd: 'April 2026',
            admitCard: 'May 2026',
            examDate: 'May 10-14, 2026',
            result: 'May 25, 2026'
        },
        pattern: {
            mode: 'Computer Based Test (CBT)',
            duration: '3 Hours',
            totalMarks: 160,
            sections: [
                { name: 'Mathematics / Biology', questions: '80', marks: 80 },
                { name: 'Physics', questions: '40', marks: 40 },
                { name: 'Chemistry', questions: '40', marks: 40 }
            ],
            markingScheme: '+1 for Correct, No Negative Marking'
        },
        eligibility: [
            'Indian National and resident of Telangana/Andhra Pradesh.',
            'Passed Class 12 with relevant subjects.',
            'Minimum 16 years of age.'
        ]
    },
    {
        id: 'nid-dat',
        name: 'NID DAT',
        fullName: 'National Institute of Design - Design Aptitude Test',
        category: 'Design',
        level: 'National',
        conductingBody: 'National Institute of Design',
        description: 'Primary entrance exam for admission to B.Des and M.Des programs at NID campuses across India.',
        website: 'https://admissions.nid.edu',
        dates: {
            applicationStart: 'September 2025',
            applicationEnd: 'December 2025',
            admitCard: 'December 2025',
            examDate: 'December 24, 2025',
            result: 'March 2026'
        },
        pattern: {
            mode: 'Pen and Paper (DAT Prelims)',
            duration: '3 Hours',
            totalMarks: 100,
            sections: [
                { name: 'Objective', questions: 'Varies', marks: 70 },
                { name: 'Subjective (Drawing)', questions: '3-4', marks: 30 }
            ],
            markingScheme: 'Varies by question'
        },
        eligibility: [
            'Passed or appearing in Class 12 in any stream.',
            'Age limit: Generally up to 20 years for General category.'
        ]
    },
    {
        id: 'nift-entrance',
        name: 'NIFT Entrance',
        fullName: 'National Institute of Fashion Technology Entrance Examination',
        category: 'Design & Fashion',
        level: 'National',
        conductingBody: 'National Testing Agency (NTA)',
        description: 'Entrance exam for undergraduate and postgraduate courses in design, management, and technology at NIFT.',
        website: 'https://nift.ntaonline.in',
        dates: {
            applicationStart: 'December 2025',
            applicationEnd: 'January 2026',
            admitCard: 'February 2026',
            examDate: 'February 5, 2026',
            result: 'March 2026'
        },
        pattern: {
            mode: 'Computer Based Test (GAT) + Paper (CAT)',
            duration: '5 Hours (Combined)',
            totalMarks: 100,
            sections: [
                { name: 'General Ability Test (GAT)', questions: '100', marks: 50 },
                { name: 'Creative Ability Test (CAT)', questions: '3', marks: 50 }
            ],
            markingScheme: 'Sectional weighting'
        },
        eligibility: [
            'Passed Class 12 in any stream.',
            'Age limit: Maximum 24 years for General category.'
        ]
    },
    {
        id: 'uceed',
        name: 'UCEED',
        fullName: 'Undergraduate Common Entrance Examination for Design',
        category: 'Design',
        level: 'National',
        conductingBody: 'IIT Bombay',
        description: 'Gateway for admission to B.Des programs at IIT Bombay, IIT Delhi, IIT Guwahati, IIT Hyderabad, IIITDM Jabalpur and and many other top institutes.',
        website: 'https://www.uceed.iitb.ac.in',
        dates: {
            applicationStart: 'October 2025',
            applicationEnd: 'November 2025',
            admitCard: 'January 2026',
            examDate: 'January 19, 2026',
            result: 'March 2026'
        },
        pattern: {
            mode: 'Computer Based Test (Part A) + Paper (Part B)',
            duration: '3 Hours',
            totalMarks: 300,
            sections: [
                { name: 'Part A (NAT, MSQ, MCQ)', questions: 'Varies', marks: 240 },
                { name: 'Part B (Drawing)', questions: '1', marks: 60 }
            ],
            markingScheme: 'Negative marking in MCQ'
        },
        eligibility: [
            'Passed Class 12 in any stream.',
            'Maximum 2 attempts in consecutive years.'
        ]
    },
    {
        id: 'ftii-jet',
        name: 'FTII JET',
        fullName: 'FTII & SRFTI Joint Entrance Test',
        category: 'Creative & Media',
        level: 'National',
        conductingBody: 'FTII Pune & SRFTI Kolkata',
        description: 'Joint entrance test for admission to high-end film and television courses at FTII and SRFTI.',
        website: 'https://applyadmission.net/ftii2026',
        dates: {
            applicationStart: 'February 2026',
            applicationEnd: 'March 2026',
            admitCard: 'April 2026',
            examDate: 'April 15-16, 2026',
            result: 'May 2026'
        },
        pattern: {
            mode: 'Pen and Paper Test',
            duration: '3 Hours',
            totalMarks: 100,
            sections: [
                { name: 'General Knowledge', questions: 'Varies', marks: 30 },
                { name: 'Specific Area (e.g. Direction)', questions: 'Varies', marks: 70 }
            ],
            markingScheme: 'Varies'
        },
        eligibility: [
            'For UG courses: Passed Class 12 in any stream.',
            'For PG courses: Bachelor\'s degree in any field (with exceptions for specific tech roles).'
        ]
    }
];
